import React from 'react'

const EmailDraft = () => {
  return (
    <div>Draft</div>
  )
}

export default EmailDraft